import * as React from "react";

import { cn } from "@/lib/utils";

// shadcn-new-york Textarea — pure DOM (no radix primitive).
// Phase 2 surfaces: HR-approval reference (step 7), video prompt field (step 1).

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      "flex min-h-[80px] w-full rounded-md border border-[var(--talenta-border-strong)] bg-[var(--talenta-surface-elevated)] px-3 py-2 text-base",
      "placeholder:text-[var(--talenta-text-muted)]",
      "focus-visible:outline-2 focus-visible:outline-offset-2",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  />
));
Textarea.displayName = "Textarea";
